// Mesquite Mafia: Underworld Combat & Dynamic Encounters
import { state, log, addXP, updateCurrencies } from '../core/state.js';
import { playSFX } from '../core/audio.js';
import { triggerGunAnimation, playActionSequence } from '../core/kinematics.js';
import { updateMissionProgress } from './missions.js';
import { syncStateToD1 } from '../services/api.js';
import { update4XTelemetry } from './world.js';

export let selectedBoss = 'mike';
export let currentIncursionRival = 'mike';

export const scannerIntelOptions = [
      {
        freq: "460.125 MHz [MESQUITE TAC-2]",
        text: '"Dispatch, Unit 44 setting up speed radar trap and interdiction stop along I-635 near Town East exit."',
        choices: [
          {
            title: "💵 Wire Bribe to Dispatcher ($3,000)",
            desc: "Diverts the patrol to another county. Clears 2 Heat Stars.",
            action: () => {
              if (state.cash >= 3000) {
                state.cash -= 3000;
                state.policeHeat = Math.max(0, state.policeHeat - 2);
                updateCurrencies();
                update4XTelemetry();
                SFX.cash();
                closeScannerIntelModal();
                log("[SCANNER INTEL]: Dispatcher bribed. 2 Heat stars cleared.");
              } else {
                alert("Need $3,000 cash.");
              }
            }
          },
          {
            title: "💨 Reroute Convoys to Frontage",
            desc: "All supply line convoys gain immunity from police heat for 5 minutes.",
            action: () => {
              SFX.tab();
              closeScannerIntelModal();
              log("[SCANNER INTEL]: Supply convoys rerouted to back frontage roads.");
            }
          },
          {
            title: "🐂 Tip Off Beau's Rodeo Crew",
            desc: "Broadcast bogus call redirecting cops to Mesquite Arena. Beau threat -30%.",
            action: () => {
              if (state.rivalThreats.beau) {
                state.rivalThreats.beau.threat = Math.max(0, state.rivalThreats.beau.threat - 30);
              }
              SFX.radio();
              update4XTelemetry();
              closeScannerIntelModal();
              log("[SCANNER INTEL]: Bogus tip dispatched to Mesquite Arena. Beau's operations delayed.");
            }
          }
        ]
      },
      {
        freq: "453.850 MHz [RETAIL LOSS PREVENTION]",
        text: '"All Town East security, armored cash transport scheduled for dock 4 pickup in 15 minutes."',
        choices: [
          {
            title: "🔫 Ambush Armored Transport (50 Product)",
            desc: "Hit the truck on exit ramp. Yields $25,000 cash, +1 Police Heat.",
            action: () => {
              if (state.product >= 50) {
                state.product -= 50;
                state.cash += 25000;
                state.policeHeat = Math.min(5, state.policeHeat + 1);
                updateCurrencies();
                update4XTelemetry();
                SFX.cash();
                closeScannerIntelModal();
                log("[SCANNER INTEL]: Transport hijacked! +$25,000 dirty cash.");
              } else {
                alert("Need 50 Product for crew supplies.");
              }
            }
          },
          {
            title: "📡 Plant GPS Tracker on Alvarez Fleet (100 Scrap)",
            desc: "Permanently siphons extra scrap & cash from Town East.",
            action: () => {
              if (state.scrap >= 100) {
                state.scrap -= 100;
                state.territories.s2.income.cash = (state.territories.s2.income.cash || 1200) + 300;
                updateCurrencies();
                SFX.vault();
                closeScannerIntelModal();
                log("[SCANNER INTEL]: GPS tracker planted. Town East passive yield increased.");
              } else {
                alert("Need 100 Scrap.");
              }
            }
          }
        ]
      }
    ];

export function getHeroMaxHp() { return 3350 + ((state.level - 1) * 100); }

export function getHeroBaseAtk() { return ((state.level - 1) * 25); }

export function getHeroBaseShield() { return ((state.level - 1) * 50); }

export function selectBoss(key) {
      SFX.citySelectAlt();
      currentBossKey = key;
      document.querySelectorAll('.boss-btn').forEach(b => b.classList.remove('active'));
      const activeBtn = Array.from(document.querySelectorAll('.boss-btn')).find(b => b.getAttribute('onclick') && b.getAttribute('onclick').includes(key));
      if (activeBtn) activeBtn.classList.add('active');
      
      const b = bosses[key];
      if (b) {
        const bossNameEl = document.getElementById('boss-name');
        const bossRoleEl = document.getElementById('boss-role');
        const bossImgEl = document.getElementById('boss-img');
        if (bossNameEl) bossNameEl.innerText = b.name;
        if (bossRoleEl) bossRoleEl.innerText = b.role;
        if (bossImgEl) bossImgEl.src = b.img;
        resetBattle();
        updateTacticalMatchup();
        log(`[COMBAT]: Loaded encounter with ${b.name} (${b.role.split('(')[1]?.replace(')', '') || 'Opp'})!`);
      }

      if (window.CombatEngine) {
        CombatEngine.setupEncounter(key);
        CombatEngine.renderLaneUI();
      }
    }

export function showDamage(num, type, target) {
      const container = document.getElementById('dmg-container');
      if (!container) return;
      const el = document.createElement('div');
      el.className = `dmg-number ${type === 'heal' ? 'dmg-heal' : type === 'crit' ? 'dmg-crit' : type === 'shield' ? 'dmg-shield' : ''}`;
      el.innerText = (type === 'heal' ? '+' : '-') + num;
      el.style.left = (Math.random() * 40 + (target === 'hero' ? -80 : 80)) + '%';
      el.style.top = (Math.random() * 40 + 20) + '%';
      container.appendChild(el);
      setTimeout(() => el.remove(), 1000);
    }

export function updateCombatUI() {
      const b = bosses[currentBossKey];
      const maxHp = getHeroMaxHp();
      
      const bPct = Math.max(0, (b.hp / b.maxHp) * 100);
      const bossBar = document.getElementById('boss-hp');
      bossBar.style.width = bPct + '%';
      bossBar.style.background = bPct > 50 ? '#10b981' : bPct > 25 ? '#fbbf24' : '#ef4444';
      document.getElementById('boss-hp-txt').innerText = `${Math.round(b.hp)} / ${b.maxHp}`;
      document.getElementById('boss-status').innerText = b.burn > 0 ? `🔥 BURN (${b.burn})` : '';

      const hPct = Math.max(0, (hero.hp / maxHp) * 100);
      const heroBar = document.getElementById('hero-hp');
      heroBar.style.width = hPct + '%';
      heroBar.style.background = hPct > 50 ? '#10b981' : hPct > 25 ? '#fbbf24' : '#ef4444';
      document.getElementById('hero-hp-txt').innerText = `${Math.round(hero.hp)} / ${maxHp}`;
      document.getElementById('hero-shield-txt').innerText = hero.shield > 0 ? `[SHIELD +${Math.round(hero.shield)}]` : '';

      document.getElementById('turn-counter').innerText = combatState.turn;
      document.getElementById('combo-fill').style.width = Math.min(100, combatState.combo * 20) + '%';
      
      ['incendiary', 'twin', 'medic'].forEach(move => {
        const cd = combatState.cooldowns[move];
        const btn = document.getElementById(`btn-${move}`);
        const cdTxt = document.getElementById(`cd-${move}`);
        if(cd > 0) {
          btn.classList.add('btn-cd');
          btn.disabled = true;
          cdTxt.innerText = `(CD: ${cd})`;
        } else {
          btn.classList.remove('btn-cd');
          btn.disabled = false;
          cdTxt.innerText = '';
        }
      });
    }

export function decrementCooldowns() {
      for(let key in combatState.cooldowns) {
        if(combatState.cooldowns[key] > 0) combatState.cooldowns[key]--;
      }
    }

export function executeTurn(action) {
      const b = bosses[currentBossKey];
      if (b.hp <= 0 || hero.hp <= 0) return;

      const baseAtk = getHeroBaseAtk();
      let comboMult = combatState.combo >= 5 ? 1.5 : 1.0;
      let isCrit = Math.random() < 0.15;
      let dmg = 0;
      let moveLog = "";

      // Tactical Counter Triangle Evaluation
      const heroStance = state.combatStance || 'bruiser';
      const bossArch = b.archetype || 'bruiser';
      let stanceHeroMult = 1.0;
      let stanceBossMult = 1.0;

      if (heroStance === 'bruiser') {
        if (bossArch === 'hitman') { stanceHeroMult = 1.35; stanceBossMult = 0.75; }
        else if (bossArch === 'biker') { stanceHeroMult = 0.80; stanceBossMult = 1.25; }
        else if (bossArch === 'police') { stanceBossMult = 0.75; }
      } else if (heroStance === 'hitman') {
        if (bossArch === 'biker') { stanceHeroMult = 1.35; stanceBossMult = 0.75; }
        else if (bossArch === 'bruiser') { stanceHeroMult = 0.80; stanceBossMult = 1.25; }
        else if (bossArch === 'police') { isCrit = isCrit || (Math.random() < 0.25); }
      } else if (heroStance === 'biker') {
        if (bossArch === 'bruiser') { stanceHeroMult = 1.35; stanceBossMult = 0.75; }
        else if (bossArch === 'hitman') { stanceHeroMult = 0.80; stanceBossMult = 1.25; }
        else if (bossArch === 'police') { combatState.combo = Math.min(5, combatState.combo + 1); }
      }

      if (action === 'focus') {
        SFX.gunshot();
        spawnBulletHole();
        dmg = 350 + Math.floor(Math.random() * 200) + baseAtk;
        if(isCrit) dmg *= 2;
        dmg = Math.floor(dmg * comboMult * stanceHeroMult);
        b.hp = Math.max(0, b.hp - dmg);
        combatState.combo = Math.min(5, combatState.combo + 1);
        showDamage(dmg, isCrit ? 'crit' : 'normal', 'boss');
        moveLog = `Focus Fire! Dealt ${dmg} DMG.`;
      } 
      else if (action === 'stonewall') {
        SFX.shield();
        hero.shield = 1400 + getHeroBaseShield();
        if (heroStance === 'bruiser') hero.shield = Math.floor(hero.shield * 1.3);
        combatState.combo = 0;
        moveLog = `[Stonewall] active! Shielded for ${hero.shield}.`;
      } 
      else if (action === 'driveby') {
        SFX.gunshot();
        spawnBulletHole();
        spawnBulletHole();
        if(Math.random() < (heroStance === 'biker' ? 0.10 : 0.25)) {
          moveLog = `[635 Drive-By] MISSED!`;
          combatState.combo = 0;
        } else {
          dmg = 800 + Math.floor(Math.random() * 400) + baseAtk;
          if(isCrit) dmg *= 2;
          dmg = Math.floor(dmg * comboMult * stanceHeroMult);
          b.hp = Math.max(0, b.hp - dmg);
          combatState.combo = Math.min(5, combatState.combo + 1);
          showDamage(dmg, isCrit ? 'crit' : 'normal', 'boss');
          moveLog = `[635 Drive-By] landed! ${dmg} DMG.`;
        }
      }
      else if (action === 'incendiary') {
        SFX.gunshot();
        spawnBulletHole();
        combatState.cooldowns.incendiary = 3;
        dmg = Math.floor((400 + baseAtk) * stanceHeroMult);
        b.hp = Math.max(0, b.hp - dmg);
        b.burn = 3;
        combatState.combo = Math.min(5, combatState.combo + 1);
        showDamage(dmg, 'normal', 'boss');
        moveLog = `[Incendiary] dealt ${dmg} DMG and ignited boss!`;
      }
      else if (action === 'twin') {
        SFX.gunshot();
        spawnBulletHole();
        spawnBulletHole();
        combatState.cooldowns.twin = 3;
        dmg = 600 + Math.floor(Math.random() * 300) + baseAtk;
        if(isCrit) dmg *= 2;
        dmg = Math.floor(dmg * comboMult * stanceHeroMult);
        b.hp = Math.max(0, b.hp - dmg);
        combatState.combo = Math.min(5, combatState.combo + 1);
        showDamage(dmg, isCrit ? 'crit' : 'normal', 'boss');
        moveLog = `[Twin Combo] devastating strike! ${dmg} DMG.`;
      }
      else if (action === 'medic') {
        playSFX('tab_switch');
        combatState.cooldowns.medic = 4;
        const heal = 800;
        hero.hp = Math.min(getHeroMaxHp(), hero.hp + heal);
        combatState.combo = 0;
        showDamage(heal, 'heal', 'hero');
        moveLog = `[Field Medic] restored ${heal} HP!`;
      }

      if (stanceHeroMult > 1.0) moveLog += " [ADVANTAGE +35%]";
      else if (stanceHeroMult < 1.0) moveLog += " [DISADVANTAGE -20%]";
      if (combatState.combo >= 5) moveLog += " (COMBO MAXED!)";
      log(moveLog);

      if (b.hp > 0 && b.burn > 0) {
        let burnDmg = 150;
        b.hp = Math.max(0, b.hp - burnDmg);
        b.burn--;
        showDamage(burnDmg, 'normal', 'boss');
        log(`Boss took ${burnDmg} burn DMG. (Turns left: ${b.burn})`);
      }

      if (b.hp > 0) {
        let bossDmg = Math.floor((b.attack + Math.floor(Math.random() * 50)) * stanceBossMult);
        let hpPct = b.hp / b.maxHp;
        if (b.thresholds.length > 0 && hpPct < b.thresholds[0]) {
          b.thresholds.shift();
          bossDmg = Math.floor(bossDmg * 1.8);
          log(`⚠️ ${b.name} ENRAGES! Unleashes a massive attack!`);
        }

        let reflected = 0;
        if (hero.shield > 0) {
          if (hero.shield >= bossDmg) {
            hero.shield -= bossDmg;
            reflected = Math.floor(bossDmg * 0.15);
            log(`${b.name} hits for ${Math.floor(bossDmg)} DMG! Absorbed. Reflected ${reflected} DMG!`);
            bossDmg = 0;
          } else {
            bossDmg -= hero.shield;
            reflected = Math.floor(hero.shield * 0.15);
            hero.shield = 0;
            log(`${b.name} broke shield! Reflected ${reflected} DMG.`);
          }
        }
        
        if (reflected > 0) {
           b.hp = Math.max(0, b.hp - reflected);
           showDamage(reflected, 'normal', 'boss');
        }

        if(bossDmg > 0 && b.hp > 0) {
          hero.hp = Math.max(0, hero.hp - bossDmg);
          SFX.hit();
          showDamage(Math.floor(bossDmg), 'normal', 'hero');
          log(`${b.name} strikes for ${Math.floor(bossDmg)} DMG!`);
        }
      }

      if (b.hp <= 0) {
        SFX.cash();
        combatState.streak++;
        log(`🏆 VICTORY! ${b.name} downed!`);
        
        const xpGain = 200 + Math.floor(Math.random() * 300);
        const cashGain = 25000 + (combatState.streak * 2000);
        const credGain = 500 + (combatState.streak * 50);
        
        let dropMsg = "";
        if(Math.random() < 0.20) {
          const scrapGain = 500;
          state.scrap += scrapGain;
          dropMsg = `<br><span style="color:var(--accent-purple); font-weight:bold;">📦 RARE DROP! +${scrapGain} Scrap Parts</span>`;
        }

        state.cred += credGain;
        state.cash += cashGain;
        addXP(xpGain);
        updateCurrencies();
        
        updateMissionProgress('daily', 'combat', 1);
        updateMissionProgress('story', 'corner_market', state.cash, true);
        updateMissionProgress('bounty', 'scrap', state.scrap, true);
        if (currentBossKey === 'mike') updateMissionProgress('boss_mike', 1);
        if (currentBossKey === 'hector') updateMissionProgress('boss_hector', 1);
        if (currentBossKey === 'beau') updateMissionProgress('boss_beau', 1);
        if (currentBossKey === 'vance') updateMissionProgress('boss_vance', 1);
        syncStateToD1();
        
        showRewardsPopup(`
          <div style="font-size:1.2rem; margin-bottom:10px;">${b.name} Defeated!</div>
          <div style="color:#4ade80;">+${xpGain} XP</div>
          <div>+$${cashGain.toLocaleString()} Cash</div>
          <div style="color:#60a5fa;">+${credGain} Cred</div>
          <div style="font-size:0.8rem; color:#94a3b8; margin-top:5px;">Streak Bonus: x${combatState.streak}</div>
          ${dropMsg}
        `);
      } else if (hero.hp <= 0) {
        log(`☠️ DEFEAT. ${b.name} overpowered you.`);
        combatState.streak = 0;
      } else {
        combatState.turn++;
        decrementCooldowns();
      }
      
      updateCombatUI();
    }

export function showRewardsPopup(content) {
      document.getElementById('rewards-content').innerHTML = content;
      document.getElementById('rewards-overlay').style.display = 'block';
      document.getElementById('rewards-popup').style.display = 'block';
    }

export function closeRewards() {
      SFX.click();
      document.getElementById('rewards-overlay').style.display = 'none';
      document.getElementById('rewards-popup').style.display = 'none';
      resetBattle();
    }

export function resetBattle() {
      SFX.click();
      const b = bosses[currentBossKey];
      b.hp = b.maxHp;
      b.burn = 0;
      b.thresholds = [0.75, 0.5, 0.25];
      hero.hp = getHeroMaxHp();
      hero.shield = getHeroBaseShield();
      combatState.turn = 1;
      combatState.combo = 0;
      combatState.cooldowns = { incendiary: 0, twin: 0, medic: 0 };
      updateCombatUI();
      log("[COMBAT]: Arena refreshed.");
    }

export function setCombatStance(stance) {
      state.combatStance = stance;
      document.querySelectorAll('.stance-card').forEach(c => c.classList.remove('active'));
      const card = document.getElementById('stance-' + stance);
      if (card) card.classList.add('active');
      playSFX('tab_switch');
      updateTacticalMatchup();
      log(`[TACTICAL STANCE]: Deployed ${stance.toUpperCase()} squad formation.`);
    }

export function updateTacticalMatchup() {
      const b = bosses[currentBossKey];
      if (!b) return;
      const heroStance = state.combatStance || 'bruiser';
      const bossArch = b.archetype || 'bruiser';
      const badge = document.getElementById('tactical-counter-badge');
      if (!badge) return;

      let stanceAdvantage = 0;
      if (heroStance === 'bruiser' && bossArch === 'hitman') stanceAdvantage = 1;
      else if (heroStance === 'hitman' && bossArch === 'biker') stanceAdvantage = 1;
      else if (heroStance === 'biker' && bossArch === 'bruiser') stanceAdvantage = 1;
      else if (heroStance === 'hitman' && bossArch === 'bruiser') stanceAdvantage = -1;
      else if (heroStance === 'biker' && bossArch === 'hitman') stanceAdvantage = -1;
      else if (heroStance === 'bruiser' && bossArch === 'biker') stanceAdvantage = -1;

      if (bossArch === 'police') {
        if (heroStance === 'bruiser') {
          badge.innerText = "DEFENSIVE POSTURE vs POLICE (-25% DMG TAKEN)";
          badge.style.background = "#065f46";
          badge.style.color = "#6ee7b7";
        } else if (heroStance === 'biker') {
          badge.innerText = "HIGHWAY EVASION vs POLICE (+COMBO SPEED)";
          badge.style.background = "#1e3a8a";
          badge.style.color = "#93c5fd";
        } else {
          badge.innerText = "SNIPER PERCH vs POLICE (+CRIT CHANCE)";
          badge.style.background = "#78350f";
          badge.style.color = "#fde047";
        }
      } else if (stanceAdvantage === 1) {
        badge.innerText = `TACTICAL ADVANTAGE (+35% DMG / -25% DMG TAKEN)`;
        badge.style.background = "#065f46";
        badge.style.color = "#6ee7b7";
      } else if (stanceAdvantage === -1) {
        badge.innerText = `TACTICAL DISADVANTAGE (-20% DMG / +25% BOSS DMG)`;
        badge.style.background = "#7f1d1d";
        badge.style.color = "#fca5a5";
      } else {
        badge.innerText = `MIRROR MATCHUP (NEUTRAL BALANCED)`;
        badge.style.background = "#334155";
        badge.style.color = "#cbd5e1";
      }
    }

export function triggerHighwayPursuit(isManual = false) {
      playSFX('march');
      const modal = document.getElementById('modal-highway-pursuit');
      if (!modal) return;
      modal.style.display = 'flex';

      state.currentPursuit = {
        distance: 1200,
        chaserDist: 75,
        heroHp: 100,
        chaserHp: 100,
        heat: state.policeHeat || 2,
        cargo: 15000 + ((state.policeHeat || 2) * 5000)
      };

      updatePursuitUI("[PURSUIT ENGAGED]: Mesquite PD interceptor on your tail! Make it to Room 114 or disable the cruiser!");
      log(`[HIGHWAY PURSUIT]: Mesquite PD engaging Grand National along US-80 frontage corridor!`);
    }

export function closeHighwayPursuit() {
      const modal = document.getElementById('modal-highway-pursuit');
      if (modal) modal.style.display = 'none';
      state.currentPursuit = null;
    }

export function updatePursuitUI(logMsg) {
      if (!state.currentPursuit) return;
      const p = state.currentPursuit;
      const distEl = document.getElementById('pursuit-distance-txt');
      const proxEl = document.getElementById('pursuit-proximity-txt');
      const logEl = document.getElementById('pursuit-log');
      const heroCar = document.getElementById('pursuit-car-hero');
      const chaserCar = document.getElementById('pursuit-car-chaser');

      if (distEl) distEl.innerText = `${Math.max(0, Math.round(p.distance))}m`;
      if (proxEl) {
        proxEl.innerText = `${Math.max(0, Math.round(p.chaserDist))}m (${p.chaserDist < 50 ? 'CRITICAL' : p.chaserDist < 120 ? 'CLOSE' : 'MODERATE'})`;
        proxEl.style.color = p.chaserDist < 50 ? '#ef4444' : p.chaserDist < 120 ? '#f59e0b' : '#4ade80';
      }
      if (logEl && logMsg) logEl.innerText = logMsg;

      if (heroCar && chaserCar) {
        const leadRatio = Math.min(1, Math.max(0, p.chaserDist / 220));
        heroCar.style.transform = `translateX(${leadRatio * 50}px)`;
        chaserCar.style.transform = `translateX(-${(1 - leadRatio) * 50}px)`;
      }
    }

export function executePursuitAction(type) {
      if (!state.currentPursuit) return;
      const p = state.currentPursuit;

      let msg = "";
      if (type === 'turbo') {
        playSFX('march');
        p.distance -= 280;
        p.chaserDist += 45;
        msg = "💨 TWIN TURBO SPOOL! Grand National opened a 45m lead on the cruiser!";
      } else if (type === 'ram') {
        SFX.hit();
        p.chaserHp -= 40;
        p.heroHp -= 15;
        p.chaserDist += 20;
        msg = "💥 PIT COUNTER-RAM! Heavy rear bumper impact crumpled the cruiser's quarter panel!";
      } else if (type === 'tire_shot') {
        SFX.gunshot();
        spawnBulletHole();
        p.chaserHp -= 30;
        p.chaserDist += 70;
        msg = "🎯 SKINNY BLACK MARKSMANSHIP! Pistol rounds pierced the cruiser's radiator & front tire!";
      } else if (type === 'offramp') {
        playSFX('tab');
        if (Math.random() < 0.65) {
          p.distance = 0;
          msg = "🛣️ GALLOWAY CUT! Hard drift under the railroad overpass broke line of sight!";
        } else {
          p.chaserDist -= 35;
          msg = "⚠️ FISHTAIL! Clipped a concrete guardrail on the ramp, cruiser closed in!";
        }
      } else if (type === 'decoy') {
        if (state.product >= 100) {
          state.product -= 100;
          updateCurrencies();
          SFX.cash();
          p.chaserDist += 160;
          p.distance -= 200;
          msg = "📦 DECOY JETTISON! 100 Product boxes exploded across highway lanes, causing pileup!";
        } else {
          msg = "❌ NO PRODUCT TO JETTISON! Cruiser gained on you!";
          p.chaserDist -= 25;
        }
      }

      if (p.distance > 0 && p.chaserDist > 0 && p.chaserHp > 0 && p.heroHp > 0) {
        const chaserSpeed = 20 + Math.floor(Math.random() * 25);
        p.chaserDist -= chaserSpeed;
        p.distance -= 100;
      }

      updatePursuitUI(msg);

      if (p.distance <= 0 || p.chaserDist >= 220 || p.chaserHp <= 0) {
        setTimeout(() => {
          SFX.cash();
          const loot = p.cargo;
          state.cash += loot;
          state.cred += 250;
          addXP(300);
          updateCurrencies();
          closeHighwayPursuit();

          playActionSequence({
            title: "HIGHWAY PURSUIT EVADED",
            icon: "🏆",
            detail: "Slipped into the Room 114 carport unnoticed! Contraband secured.",
            rewardText: `+$${loot.toLocaleString()} Cash • +💎 250 Street Cred • +300 XP`,
            shots: 2,
            onComplete: () => log(`[PURSUIT ESCAPE]: Contraband successfully laundered. +$${loot.toLocaleString()}`)
          });
        }, 700);
      } else if (p.chaserDist <= 0 || p.heroHp <= 0) {
        setTimeout(() => {
          SFX.hit();
          const penalty = Math.min(state.cash, 6000);
          state.cash -= penalty;
          state.policeHeat = Math.min(5, (state.policeHeat || 1) + 1);
          updateCurrencies();
          update4XTelemetry();
          closeHighwayPursuit();

          playActionSequence({
            title: "PURSUIT BUSTED",
            icon: "🚨",
            detail: "Spike strip contact! Car forced into median ditch.",
            rewardText: `-$${penalty.toLocaleString()} Bribe Paid • Heat +1 Star`,
            shots: 0,
            onComplete: () => log(`[BUSTED]: Police impounded contraband. Bribed way out for $${penalty.toLocaleString()}.`)
          });
        }, 700);
      }
    }

export function openScannerIntelModal() {
      SFX.radio();
      const modal = document.getElementById('modal-scanner-intel');
      if (!modal) return;
      modal.style.display = 'flex';

      const intel = scannerIntelOptions[Math.floor(Math.random() * scannerIntelOptions.length)];
      const bodyEl = document.getElementById('scanner-intel-body');
      if (bodyEl) bodyEl.innerText = intel.text;

      const choicesContainer = document.getElementById('scanner-choices-container');
      if (choicesContainer) {
        choicesContainer.innerHTML = '';
        intel.choices.forEach(c => {
          const btn = document.createElement('button');
          btn.className = 'tactical-choice-btn';
          btn.innerHTML = `
            <div class="tactical-choice-title">${c.title}</div>
            <div class="tactical-choice-desc">${c.desc}</div>
          `;
          btn.onclick = c.action;
          choicesContainer.appendChild(btn);
        });
      }
    }

export function closeScannerIntelModal() {
      const modal = document.getElementById('modal-scanner-intel');
      if (modal) modal.style.display = 'none';
    }

export function openIncursionAlert(rivalKey = 'mike') {
      currentIncursionRival = rivalKey;
      SFX.hit();
      const modal = document.getElementById('modal-incursion-alert');
      if (!modal) return;
      modal.style.display = 'flex';

      const rival = state.rivalThreats[rivalKey] || { name: "Rival Crew", target: 's1', archetype: 'bruiser' };
      const targetSector = sectorData[rival.target] || { title: "Sector Perimeter" };

      const titleEl = document.getElementById('incursion-title');
      const detailEl = document.getElementById('incursion-detail');

      if (titleEl) titleEl.innerText = `TERRITORY INCURSION: ${rival.name.toUpperCase()} ATTACKING!`;
      if (detailEl) {
        detailEl.innerHTML = `
          <div style="font-weight:700; color:#f87171; margin-bottom:6px;">⚠️ HOSTILE CONVOY DETECTED</div>
          <div><strong>${rival.name}</strong> (${rival.archetype.toUpperCase()}) is raiding <strong>${targetSector.title}</strong> with heavy firepower!</div>
          <div style="font-size:0.8rem; color:#94a3b8; margin-top:6px;">Matchup: Deploy the counter-archetype formation to repel without casualties.</div>
        `;
      }
    }

export function closeIncursionModal() {
      const modal = document.getElementById('modal-incursion-alert');
      if (modal) modal.style.display = 'none';
    }

export function respondToIncursion(tactic) {
      const rival = state.rivalThreats[currentIncursionRival] || { archetype: 'bruiser', target: 's1' };
      const targetTerritory = state.territories[rival.target];
      
      let success = false;
      let summary = "";

      if (tactic === 'stonewall') {
        if (rival.archetype === 'hitman') {
          success = true;
          summary = "Fat Twin's Bruiser Wedge absorbed the sniper fire and crushed Hector's raiders!";
        } else {
          success = Math.random() < 0.6;
          summary = success ? "Bruisers held the perimeter line!" : "Bruisers flanked by faster raiders; minor damage sustained.";
        }
      } else if (tactic === 'biker_ambush') {
        if (rival.archetype === 'bruiser') {
          success = true;
          summary = "Skinny Black's high-speed highway ambush completely circled Big Mike's heavy flatbeds!";
        } else {
          success = Math.random() < 0.6;
          summary = success ? "Biker ambush disrupted the raiders!" : "Crossfire caught the bikes; defensive stall.";
        }
      } else if (tactic === 'garrison') {
        if (state.product >= 100) {
          state.product -= 100;
          success = true;
          summary = "Garrison opened sustained fire with supplied ammo, repelling the incursion!";
        } else {
          summary = "Insufficient product for ammunition! Garrison forced to give up ground.";
          success = false;
        }
      } else if (tactic === 'bribe') {
        if (state.cred >= 250) {
          state.cred -= 250;
          success = true;
          summary = "Vanessa Vance redirected Mesquite PD cruisers to intercept and impound the raiders!";
        } else {
          summary = "Insufficient Street Cred to call in City Hall favor!";
          success = false;
        }
      }

      if (state.rivalThreats[currentIncursionRival]) {
        state.rivalThreats[currentIncursionRival].threat = 15;
      }

      if (success) {
        SFX.cash();
        addXP(250);
        state.cash += 8000;
        if (targetTerritory) targetTerritory.control = Math.min(100, targetTerritory.control + 10);
        playActionSequence({
          title: "INCURSION REPELLED",
          icon: "🛡️",
          detail: summary,
          rewardText: "+$8,000 Repelled Bounty • +250 XP",
          shots: 3
        });
      } else {
        SFX.hit();
        if (targetTerritory) targetTerritory.control = Math.max(10, targetTerritory.control - 20);
        playActionSequence({
          title: "TERRITORY DAMAGED",
          icon: "⚠️",
          detail: summary,
          rewardText: "-20% Sector Control",
          shots: 1
        });
      }

      updateCurrencies();
      update4XTelemetry();
      closeIncursionModal();
    }

export function aiTick() {
      // 1. Advance convoys
      if (state.convoys && state.convoys.length > 0) {
        for (let i = state.convoys.length - 1; i >= 0; i--) {
          const c = state.convoys[i];
          if (!c.active) continue;
          c.progress += (c.speed || 0.0035);
          if (c.progress >= 1.0) {
            c.active = false;
            if (c.type === 'cash') state.cash += c.value;
            else if (c.type === 'scrap') state.scrap += c.value;
            else if (c.type === 'product') state.product += c.value;
            
            SFX.cash();
            updateCurrencies();
            log(`[CONVOY DELIVERED]: Armored shipment reached ${sectorData[c.to]?.title || 'Sector'}! +${c.value} ${c.type.toUpperCase()}`);
            state.convoys.splice(i, 1);
          }
        }
      }

      // 2. Advance rival threat meters
      if (state.rivalThreats) {
        for (let rKey in state.rivalThreats) {
          const r = state.rivalThreats[rKey];
          if (r.threat < 100) {
            r.threat += Math.floor(Math.random() * 3) + 1;
            if (r.threat >= 100) {
              r.threat = 100;
              openIncursionAlert(rKey);
            }
          }
        }
      }

      update4XTelemetry();
    }

